module.exports = __webpack_public_path__ + "static/img/son10.979c0683.png";